// The rule lives in platform-wire so the Link in Bio renderer and the app,
// which do not depend on this package, apply the same one.
export { eventDisplayTitle } from "@libs/platform-wire";
